<span matTooltip="{{ getTimeZone(utcTime) }}" class="custom-tooltip">{{ localTime }}</span>